module.exports = __webpack_public_path__ + "img/Brainstorming.b9c7ab4b.png";